<template>
  <div class="home div-100" ref="container">
    <v-img
      :src="require('_shared/assets/bg2.jpg')"
      height="calc(100vh)"
      min-height="768"
      max-height="1080"
      style="top: -96px"
    >
      <div class="d-flex flex-column align-center div-100 justify-center px-16">
        <h1
          class="secondary--text event-title pb-3"
          v-html="$t('page.title')"
        ></h1>
        <div
          class="
            d-flex
            flex-row
            align-space-around
            justify-space-around
            img-wrapper
            pb-14
          "
        ></div>
        <h1
          class="secondary--text event-subtitle"
          v-html="$t('page.subtitle')"
        ></h1>
        <h1 class="black--text event-date" v-html="$t('page.date')"></h1>
        <RegisterOrLogin v-if="active" />
      </div>
    </v-img>

    <div>
      <LandingPageDescription />
      <ParterFrame :headline="$t('page.partners.headline')" class="my-8" />
    </div>    
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LandingPageDescription from "../components/LandingPage/Description";
import ParterFrame from "../components/Partners/PartnerFrame";
import RegisterOrLogin from "./components/RegisterOrLogin";

export default {
  name: "Home",
  components: {
    LandingPageDescription,
    ParterFrame,
    RegisterOrLogin,
  },
  data: () => ({
    EventItems: [],
  }),
  computed:{
    ...mapGetters(['EventInfo']),
    active(){
      if(this.EventInfo==undefined)
      return false
      else
      return this.EventInfo.active
    }
  },
  async beforeCreate() {
    this.EventItems = await this.$store.dispatch("getEventItems");
  },
};
</script>

<style lang="scss" scoped>
.thin {
  font-family: "Thin";
}
.event-title {
  font-family: "Bold";
  font-size: 100px;
  line-height: 1;
  padding-bottom: 48px;
}
.event-subtitle {
  font-family: "Thin";
  font-size: 52px;
}
.event-date {
  font-family: "Thin";
  font-size: 24px;
}
.event-title,
.event-subtitle,
.event-date {
  text-align: center;
}

.img-wrapper {
  width: 500px;
}
.img-logo {
  height: 24px;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .event-title {
    font-size: 83px;
  }
  .event-subtitle {
    font-size: 17px;
  }
  .event-date {
    font-size: 17px;
  }
  .img-wrapper {
    width: 100px;
  }
  .img-logo {
    height: 12px;
  }
}
</style>
